import { render } from "./subscribers.vue?vue&type=template&id=3139415a"
import script from "./subscribers.vue?vue&type=script&lang=js"
export * from "./subscribers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__